import React, { useRef } from "react";
import { SystemPageType } from "../../../../Model/SystemModels";
import { ListHeaderEntry } from "../../../Common/Template/List/ListHeaderEntry";
import PageContainer, { PageContainerBase } from "../../../Common/Template/PageContainer";
import { ContainerType, PageDefinitionContainer } from "../../../Common/Template/PageDefinitionContainer";
import { AdminIndustryCard } from "../AdminIndustryCard/AdminIndustryCard";
import { t } from "i18next";

export const AdminIndustryList : React.FC = () => {
    const cardRef = useRef<PageContainerBase>(null);

    return (
        <>
            <PageContainer endpoint="/odata/industry" pageType={SystemPageType.List} title={t("adminCenter:industryList:title")} backAllowed insertAllowed updateAllowed deleteAllowed cardRef={cardRef}>
                <PageDefinitionContainer type={ContainerType.Action}></PageDefinitionContainer>
                <PageDefinitionContainer type={ContainerType.PageStructure}>
                    <ListHeaderEntry fieldName="code" name={t("adminCenter:industryList:fields:code")} minWidth={100} maxWidth={200} />
                    <ListHeaderEntry fieldName="description" name={t("adminCenter:industryList:fields:description")} minWidth={900} maxWidth={1000} />
                </PageDefinitionContainer>
            </PageContainer>
            <AdminIndustryCard ref={cardRef} />
        </>
    );
}